import LegalDocumentPage from "./LegalDocumentPage";

export default function Cookie() {
  return <LegalDocumentPage documentKey="cookie" />;
}
